var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('data-select',{attrs:{"value":_vm.timeSpentCalculation.searchValue,"dataSourceId":_vm.trackingField.dataSourceId},on:{"inputValue":_vm.timeSpentCalculationChange}})}
var staticRenderFns = []

export { render, staticRenderFns }